// extracted by mini-css-extract-plugin
export default {"background":"style_background__hbRXy","container":"style_container__Y4TCv","circle":"style_circle__d5pjK","checkIcon":"style_checkIcon__CROkQ"};